import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import wordmarkWhite from '../assets/site/logos/tarana-wordmark-white.png';

export const NAV_LINKS = [
  { label: 'For Artists', path: '/for-artists' },
  { label: 'For Organizations', path: '/for-organizations' },
  { label: 'For Listeners', path: '/for-listeners' },
  { label: 'About', path: '/about' },
];

export function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const goTo = (path: string) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <nav className={`nav${scrolled ? ' scrolled' : ''}${menuOpen ? ' menu-open' : ''}`}>
      <div className="nav-inner">
        <div className="nav-logo" onClick={() => goTo('/')}>
          <img src={wordmarkWhite} alt="Tarana" />
        </div>
        <div className="nav-links">
          {NAV_LINKS.map((l) => (
            <button
              key={l.path}
              className={`nav-link${location.pathname === l.path ? ' active' : ''}`}
              onClick={() => navigate(l.path)}
            >
              {l.label}
            </button>
          ))}
        </div>
        <div className="nav-actions">
          <button className="btn btn-primary btn-sm" onClick={() => navigate('/redirect')}>Get the app</button>
        </div>
        <button
          type="button"
          className={`nav-menu-toggle${menuOpen ? ' open' : ''}`}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className={`nav-mobile-menu${menuOpen ? ' open' : ''}`} aria-hidden={!menuOpen}>
        <button type="button" className="nav-mobile-backdrop" aria-label="Close menu" onClick={() => setMenuOpen(false)} />
        <div className="nav-mobile-panel">
          {NAV_LINKS.map((l) => (
            <button
              key={l.path}
              type="button"
              className={`nav-mobile-link${location.pathname === l.path ? ' active' : ''}`}
              onClick={() => goTo(l.path)}
            >
              {l.label}
            </button>
          ))}
          <button type="button" className="btn btn-primary nav-mobile-cta" onClick={() => goTo('/redirect')}>
            Get the app
          </button>
        </div>
      </div>
    </nav>
  );
}
